// extracted by mini-css-extract-plugin
export default {"carousel":"style_carousel__II23O","control":"style_control__lGBfx","imgContainer":"style_imgContainer__8H+V-"};